import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { IEditPatio } from './patio.model';

@Injectable({
  providedIn: 'root'
})
export class PatioService {
  constructor(private http: HttpClient) {}

  public EditPatio(pkPatio: number, body: IEditPatio): Observable<any> {
    const url = `${environment.baseURL}Patio/UpdatePatio?id=${pkPatio}`;

    return this.http.put<any>(url, body);
  }

  public GetPatios(
    idEmpresa?: string,
    pageNumber?: number,
    pageSize?: number
  ): Observable<any> {
    const invalid = ['', undefined, 0, NaN];

    const url = `${environment.baseURL}Patio/GetPatios`;
    const params: any = {};

    if (!invalid.includes(idEmpresa)) {
      params.FK_EPSA = idEmpresa;
    }

    if (!invalid.includes(pageNumber)) {
      params.PAGE_NUMBER = pageNumber;
    }

    if (!invalid.includes(pageSize)) {
      params.PAGE_SIZE = pageSize;
    }

    return this.http.get<any>(url, { params });
  }

  public GetCapacidadePatio(): Observable<any> {
    const url = `${environment.baseURL}Patio/GetCapacidadePatio`;

    return this.http.get<any>(url);
  }

  public GetPatioById(id?: number): Observable<any> {
    let url = `${environment.baseURL}Patio/GetPatioById`;
    if (id !== undefined) {
      url += `?id=${id}`;
    }
    return this.http.get<any>(url);
  }

  public GetCapacidadePatioVerification(carga: number, destinatario: number, data: string): Observable<any> {
    let url = `${environment.baseURL}Patio/GetCapacidadePatioVerification?DataAgendamento=${data}&Carga=${carga}&Destinatario=${destinatario}`;
    return this.http.get<any>(url);
  }
}
